

















import {Component} from 'vue-property-decorator';

import Menu from '../components/Menu.vue';
import Footer from '@/components/Footer.vue';
import MainImage from '@/components/MainImage.vue';
import {Mixins} from 'vue-mixin-decorator';
import PageVue from '@/script/PageVue';
import ImageManager from '@/script/ImageManager';
import TextManager from '@/script/TextManager';

@Component({
  components: {MainImage, Footer, Menu },
})
export default class RewardPage extends Mixins<PageVue>(PageVue) {
  private imageUrl: string = ImageManager.INSTANCE.get('Reward')!;
  private rewardMessage: string = TextManager.INSTANCE.get('reward-message')!;

  private downloadReward() {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', this.imageUrl, true);
    xhr.responseType = 'blob';
    xhr.onload = this.downloadImageToLocal.bind(this);
    xhr.send();
  }

  // ローカルへのダウンロード処理(画像リクエスト完了時に動作)
  private downloadImageToLocal() {
    const dlLink = document.createElement('a');

    dlLink.href = this.imageUrl;

    dlLink.download = 'reward20200607.jpg';

    document.body.insertAdjacentElement('beforeend', dlLink);
    dlLink.click();
    dlLink.remove();

    setTimeout(() => {
      window.URL.revokeObjectURL(this.imageUrl);
    }, 1000);
  }
}
